/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetMCPServerDetailsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetMCPServerDetailsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetMCPServerDetailsSecurity = {
  option1?: GetMCPServerDetailsSecurityOption1 | undefined;
  option2?: GetMCPServerDetailsSecurityOption2 | undefined;
};

export type GetMCPServerDetailsRequest = {
  /**
   * ID of the registry
   */
  registryId: string;
  /**
   * Server specifier (e.g., 'io.github.user/server')
   */
  serverSpecifier: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetMCPServerDetailsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetMCPServerDetailsSecurityOption1$outboundSchema: z.ZodMiniType<
  GetMCPServerDetailsSecurityOption1$Outbound,
  GetMCPServerDetailsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getMCPServerDetailsSecurityOption1ToJSON(
  getMCPServerDetailsSecurityOption1: GetMCPServerDetailsSecurityOption1,
): string {
  return JSON.stringify(
    GetMCPServerDetailsSecurityOption1$outboundSchema.parse(
      getMCPServerDetailsSecurityOption1,
    ),
  );
}

/** @internal */
export type GetMCPServerDetailsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetMCPServerDetailsSecurityOption2$outboundSchema: z.ZodMiniType<
  GetMCPServerDetailsSecurityOption2$Outbound,
  GetMCPServerDetailsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getMCPServerDetailsSecurityOption2ToJSON(
  getMCPServerDetailsSecurityOption2: GetMCPServerDetailsSecurityOption2,
): string {
  return JSON.stringify(
    GetMCPServerDetailsSecurityOption2$outboundSchema.parse(
      getMCPServerDetailsSecurityOption2,
    ),
  );
}

/** @internal */
export type GetMCPServerDetailsSecurity$Outbound = {
  Option1?: GetMCPServerDetailsSecurityOption1$Outbound | undefined;
  Option2?: GetMCPServerDetailsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetMCPServerDetailsSecurity$outboundSchema: z.ZodMiniType<
  GetMCPServerDetailsSecurity$Outbound,
  GetMCPServerDetailsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetMCPServerDetailsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetMCPServerDetailsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getMCPServerDetailsSecurityToJSON(
  getMCPServerDetailsSecurity: GetMCPServerDetailsSecurity,
): string {
  return JSON.stringify(
    GetMCPServerDetailsSecurity$outboundSchema.parse(
      getMCPServerDetailsSecurity,
    ),
  );
}

/** @internal */
export type GetMCPServerDetailsRequest$Outbound = {
  registry_id: string;
  server_specifier: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetMCPServerDetailsRequest$outboundSchema: z.ZodMiniType<
  GetMCPServerDetailsRequest$Outbound,
  GetMCPServerDetailsRequest
> = z.pipe(
  z.object({
    registryId: z.string(),
    serverSpecifier: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      registryId: "registry_id",
      serverSpecifier: "server_specifier",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getMCPServerDetailsRequestToJSON(
  getMCPServerDetailsRequest: GetMCPServerDetailsRequest,
): string {
  return JSON.stringify(
    GetMCPServerDetailsRequest$outboundSchema.parse(getMCPServerDetailsRequest),
  );
}
